import {v3} from "oc-threejs/short3";
import LengthRulerRepresentation from "oc-virtual3d/representations/LengthRulerRepresentation";
import simpleSizeFormatter from "oc-threejs/objects/rulers/simpleSizeFormatter";
import Maths3 from "oc-threejs/Maths3";
import Scenes from "oc-threejs/Scenes";

/**
 * Stellt LengthRuler um eine Box für ungefähr die folgende Kameraperspektive dar:
 *
 *              xtop
 *              ---
 *             +---+
 *    ztop  / /   /| |  yright
 *           +---+ +
 *   yleft | |   |/  /  zbottom
 *           +---+
 *            ---
 *          xbottom
 *
 * Beispiel: Der obere Lengthruler ist dann xtop.
 *
 * Es muss angegeben werden, welche Lengthruler dargestellt werden: boxRuler.description.show=true
 */
export default class BoxRuler extends THREE.Group {

    objects = {
        xtop: null,
        xbottom: null,
        yleft: null,
        yright: null,
        ztop: null,
        zbottom: null,
    };

    description = {
        xtop: {
            show: false,
            gridPoints: [v3(0, 1, 0), v3(1, 1, 0)],
            rulerOffset: v3(0, 20, 0),
            textOffset: v3(0, 5, 0),
            normal: v3(0, 0, 1),
            textQuaternion: Maths3.quaternion.zero,
        },
        xbottom: {
            show: false,
            gridPoints: [v3(0, 0, 1), v3(1, 0, 1)],
            rulerOffset: v3(0, 0.5, 20),
            textOffset: v3(0, 5, 10),
            normal: v3(0, 1, 0),
            textQuaternion: Maths3.quaternion.zero,
        },
        yleft: {
            show: false,
            gridPoints: [v3(0, 0, 1), v3(0, 1, 1)],
            rulerOffset: v3(0, 0.5, 20),
            textOffset: v3(1, 0, 10),
            normal: v3(1, 0, 0),
            textQuaternion: Maths3.quaternion.y90,
        },
        yright: {
            show: false,
            gridPoints: [v3(1, 0, 0), v3(1, 1, 0)],
            rulerOffset: v3(20, 0.5, 0),
            textOffset: v3(10, 0, 1),
            normal: v3(0, 0, 1),
            textQuaternion: Maths3.quaternion.zero,
        },
        ztop: {
            show: false,
            gridPoints: [v3(0, 1, 0), v3(0, 1, 1)],
            rulerOffset: v3(0, 20, 0),
            textOffset: v3(0, 5, 0),
            normal: v3(1, 0, 0),
            textQuaternion: Maths3.quaternion.y90,
        },
        zbottom: {
            show: false,
            gridPoints: [v3(1, 0, 0), v3(1, 0, 1)],
            rulerOffset: v3(20, 0.5, 0),
            textOffset: v3(10, 5, 0),
            normal: v3(0, 1, 0),
            textQuaternion: Maths3.quaternion.zero,
        },
    };

    updateBox(box) {
        _.keys(this.description).forEach(key=>{
            if (this.description[key].show && this.objects[key]==null) {
                const options = this.getRulerOptions(box,this.description[key]);
                this.objects[key] = new LengthRulerRepresentation(options);
                this.add(this.objects[key]);
            } else if (!this.description[key].show && this.objects[key]!=null) {
                Scenes.remove(this.objects[key]);
                this.objects[key] = null;
            }
            if (this.objects[key]!=null) {
                const options = this.getRulerOptions(box,this.description[key]);
                this.objects[key].update(options);
            }
        });
    }

    getRulerOptions(box,description) {
        const points = description.gridPoints.map(v=>box.grid(v).add(description.rulerOffset));
        return {
            point1: points[0],
            point2: points[1],
            normal: description.normal,
            offsets: [0, -6, 6],
            showLines: true,
            showLinesIfLengthGreaterThen: 30,
            sizeFormatter: simpleSizeFormatter(),
            textQuaternion: description.textQuaternion,
            textOffset: description.textOffset,
            fontHeight: 10,
            fontDepthTest: true,
            fontColor: "black",
            backgroundColor: null,
            negative: false,
            textAsSprite: false,
            onTap: null,
            moveTextUpinHeightMultiplies: 0,
            textCanvasCallback: undefined,
            createMeshMaterial: () => new THREE.LineBasicMaterial({color: 0x000000})
        };
    }

}
